import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
  BtnContainer,
  Container,
  Content,
  Title,
} from "./styles";

interface IDeleteModal {
  visible: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteModal: FC<IDeleteModal> = ({
  visible,
  loading,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('activities');

  return (
    <Modal
      visible={visible}
      width={450}
      footerButtons={null}
    >
      <Container>
        <Title>
          <span className="textTitle">
            {t('comments.deleteModalTitle')}
          </span>
        </Title>

        <Content>
          <span className="contentText">
            {t('comments.deleteModalText')}
          </span>
        </Content>

        <BtnContainer>
          <Button type="text" disabled={loading} onClick={onCancel}>
            {t('comments.cancel')}
          </Button>
          <Button
            type="primary"
            className="deleteBtn"
            onClick={loading ? undefined : onConfirm}
            primaryDanger
          >
            {loading && (
              <Spin
                indicator={
                  <LoadingOutlined
                    color="white"
                    style={{ fontSize: 12, color: 'white', marginRight: 6 }}
                  />
                }
              />
            )}
            {loading ? t('comments.deleting') : t('comments.delete')}
          </Button>
        </BtnContainer>
      </Container>
    </Modal>
  )
}

export default DeleteModal;
